import React, { useEffect } from 'react';
import clsx from 'clsx';
import { Paper, makeStyles, CircularProgress } from '@material-ui/core';
import { Card, CardActionArea, CardContent, Typography, Grid } from "@material-ui/core";
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';


const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        width: '100%'
    },
    fixedHeight: {
        height: '100%',
    },
}));

function SupplyDistributionFlow() {
    const classes = useStyles();
    const history = useHistory();
    const { userData } = CheckUserProvider();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

    useEffect(async () => {
        var isLogin = localStorage.getItem(process.env.REACT_APP_EMPLOYER_ISLOGIN) || false;
        if (!isLogin || isLogin == "false") {
            history.push("/activity/Login");
        }
    }, [])

    const handleCardClick = (path) => {
        history.push(path);
    };

    return (
        <>
            {!userData ?
                (<div className="row">
                    <div className="col-md-12 text-center p-4">
                        <CircularProgress />
                    </div>
                </div>) :
                (<div className="allProductsAndSales">
                    <Paper className={fixedHeightPaper}>
                        <Helmet>
                            <meta name="description" content="Find Order you have posted till now." />
                            <title>Distribution | Kaipsool Pharmatech</title>
                        </Helmet>
                        <div className="row d-flex justify-content-center align-items-center text-center">
                            <div className="col-md-12 justify-content-center align-items-center">
                                <h5>Distribution Flow</h5>
                                <p>Please select Purchase or Pickup</p>
                            </div>
                            <Grid container spacing={3} justifyContent="center" alignItems="center">
                                <Grid item>
                                    <Card
                                        style={{ width: 200 }}
                                        onClick={() => handleCardClick("/supply/purchase")}
                                    >
                                        <CardActionArea>
                                            <CardContent style={{ textAlign: "center" }}>
                                                <Typography variant="h5" component="h2">
                                                    Purchase
                                                </Typography>
                                            </CardContent>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                                <Grid item>
                                    <Card
                                        style={{ width: 200 }}
                                        onClick={() => handleCardClick("/supply/pickup")}
                                    >
                                        <CardActionArea>
                                            <CardContent style={{ textAlign: "center" }}>
                                                <Typography variant="h5" component="h2">
                                                    Pickup
                                                </Typography>
                                            </CardContent>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            </Grid>
                        </div>
                    </Paper>
                </div>)
            }
        </>
    )
}

export default SupplyDistributionFlow
